/**
 * Parse API timestamps as absolute instants.
 * Naive ISO / MySQL-style strings from our API are UTC wall-clock; append Z so
 * `Date` matches the real instant in every user locale.
 * @param {string|Date|number|null|undefined} value
 * @returns {Date|null}
 */
export function parseServerInstant(value) {
	if (value == null || value === '') return null
	if (value instanceof Date) {
		return Number.isNaN(value.getTime()) ? null : value
	}
	if (typeof value === 'number' && Number.isFinite(value)) {
		const d = new Date(value)
		return Number.isNaN(d.getTime()) ? null : d
	}
	const s = String(value).trim()
	if (!s) return null
	if (/(Z|z|[+-]\d{2}:\d{2}(:\d{2})?)$/.test(s)) {
		return new Date(s)
	}
	if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
		const d = new Date(`${s}T00:00:00Z`)
		return Number.isNaN(d.getTime()) ? null : d
	}
	const normalized = s.includes('T') ? s : s.replace(' ', 'T', 1)
	if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(normalized)) {
		const d = new Date(`${normalized}Z`)
		return Number.isNaN(d.getTime()) ? null : d
	}
	const d = new Date(s)
	return Number.isNaN(d.getTime()) ? null : d
}
